import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
//import { Observable, catchError, from, mergeMap, of } from 'rxjs';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  RetrievePriceCardDataPayload,
  retrievePriceCardDataFailure,
  retrievePriceCardDataSuccess,
} from '@store/price-card/price-card-data/price-card-data.slice';

export const retrievePriceCardDataEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('priceCardData/retrievePriceCardData'),
    //mergeMap((action: PayloadAction<RetrievePriceCardDataPayload>) => {
    concatMap((action: PayloadAction<RetrievePriceCardDataPayload>) => {
      const { commercialOperationDateIds, priceZoneId, technologyId } = action.payload;
      return from(
        dependencies.priceCardDataGateway.list(priceZoneId, technologyId, commercialOperationDateIds),
      ).pipe(
        mergeMap(listItems => {
          const codPriceCardIdMap: Record<number, number> = {};
          commercialOperationDateIds.forEach((codId, index) => {
            if (listItems[index]) {
              codPriceCardIdMap[codId] = listItems[index].id;
            }
          });
          const priceCardIds = listItems.map(item => item.id);
          return from(dependencies.priceCardDataGateway.getData(priceCardIds)).pipe(
            mergeMap(priceCardData =>
              of(retrievePriceCardDataSuccess({ codPriceCardIdMap, priceCardData })),
            ),
          );
        }),
        catchError(() => of(retrievePriceCardDataFailure('Failed to retrieve price card data'))),
      );
    }),
  );

